// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"394":"codebuild","640":"pipelines"}[chunkId] + "." + {"394":"9dd9b35a","640":"b5b597d3"}[chunkId] + ".js";
};